import { app } from '../../../../app';

app.factory('ComputersReportService', ComputersReportService);

/** @ngInject */
function ComputersReportService($resource) {
	
 var rootUrl = 'app/rest/company/:companyId/report';
    
    return {
        computersReport :  $resource(rootUrl,{},
                { 'getComputersReport' : {
            method : 'GET',
            url: rootUrl+'/computers',
            isArray : true,
            params : {
                companyId : '@companyId',
                appId  : '@appId'	
            }
                }
        }),

    }
    
}



// WEBPACK FOOTER //
// ./src/portal/states/company/reports/computers-report/computers-report.service.js